module.exports = __webpack_public_path__ + "img/message-image.3eaff094.svg";